import React from 'react';
import { Switch } from '@/components/ui/switch';
import { Eye, EyeOff } from 'lucide-react';
import { useCompanySettings } from '@/hooks/useCompanySettings';

interface ShowPricesToggleProps {
  showLabel?: boolean;
}

export const ShowPricesToggle: React.FC<ShowPricesToggleProps> = ({ showLabel = false }) => {
  const {
    showPrices,
    setShowPrices,
    saving,
    isAdmin
  } = useCompanySettings();

  if (!isAdmin) return null;

  return (
    <div className="flex items-center gap-3">
      {showPrices ? <Eye className="h-4 w-4 text-muted-foreground" /> : <EyeOff className="h-4 w-4 text-muted-foreground" />}
      <Switch 
        checked={showPrices} 
        onCheckedChange={setShowPrices}
        disabled={saving}
        aria-label="Afficher les prix en caisse"
      />
      {showLabel && (
        <span className="text-sm text-muted-foreground">
          {showPrices ? "Prix affichés" : "Prix masqués"}
        </span>
      )}
    </div>
  );
};